import api from "api";
import { QueryKey, useMutation, useQueryClient } from "react-query";
import { queryKeys } from "utils/misc";
import { UpdateReferralParams, ReferralTrackingResponse } from "./types";

interface MutationContext {
  previous: { key: QueryKey; data: ReferralTrackingResponse | undefined }[];
}

const useUpdateReferral = () => {
  const queryClient = useQueryClient();

  return useMutation<unknown, unknown, UpdateReferralParams, MutationContext>(
    ({ id, field, value }) =>
      api.call(`/uk/referral_tracking/${id}`, {
        method: "PATCH",
        data: { [field]: value },
      }),
    {
      onMutate: async ({ id, field, value }) => {
        await queryClient.cancelQueries(queryKeys.ukReferralTracking());

        const queries = queryClient.getQueriesData<ReferralTrackingResponse>(queryKeys.ukReferralTracking());
        const previous = queries.map(([key, data]) => ({ key, data }));

        queryClient.setQueriesData<ReferralTrackingResponse | undefined>(
          queryKeys.ukReferralTracking(),
          (old) => {
            if (!old) return old;
            return {
              ...old,
              items: old.items.map((item) => (item.id === id ? { ...item, [field]: value } : item)),
            };
          }
        );

        return { previous };
      },
      onError: (_err, _vars, context) => {
        if (context?.previous) {
          context.previous.forEach(({ key, data }) => {
            queryClient.setQueryData(key, data);
          });
        }
      },
    }
  );
};

export default useUpdateReferral;
